export enum APP_ENV {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export enum Feature_Flags {
  PORTAL_KIOSKS_REVAMP = 'portal_kiosk_revamp',
  PORTAL_QR_ORDERING_REVAMP = 'portal_qr_ordering_revamp',
  PORTAL_ORDERS_EXPORTING = 'portal_orders_exporting',
  PORTAL_CUSTOMER_EXPORT = 'portal_customer_export',
  PORTAL_LOYALTY_REVAMP = 'portal_loyalty_revamp',
  METABASE_FOODICS_WORKSPACE='metabase_foodics_workspace',
  METABASE_FOODICS_ALL_REPORTS='metabase_foodics_all_reports',
  PORTAL_MENU_REVAMP = 'portal_menu_revamp',
  PORTAL_SEQUENCE_NUMBER = 'fe_enable_order_sequence_number',
  PUBLISH_MENU_OPTIMIZATION_BUTTON = 'publish_menu_optimization_button',
  PORTAL_DISABLE_NOTIFICATION='portal_disable_notification'

}

export const ENVIRONMENTS_HAVE_API_SWITCHER = ['development', 'staging'];
